import { render, staticRenderFns } from "./sysStudentExam.vue?vue&type=template&id=08f98d0d&"
import script from "./sysStudentExam.vue?vue&type=script&lang=js&"
export * from "./sysStudentExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports